module.exports = __webpack_public_path__ + "img/logo.7698ba6f.jpg";